import { CardTable } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  useTableProps,
  CurrencyValue,
  RelativeDateTime,
  TableSkeleton
} from '@blockanalitica/ui';
import { useApi, PaginatedResponse } from '@/api';

type LiquidationBuyersData = {
  address: string;
  market_address: string;
  underlying_address: string;
  underlying_symbol: string;
  market_symbol: string;
  wallet_address: string;
  base_amount: string | null;
  collateral_amount: string | null;
  market_underlying_address: string;
  market_underlying_symbol: string;
  datetime: string;
};

export default function CollateralBuyersTable({
  marketAddress,
  network,
  walletAddress
}: {
  marketAddress: string;
  network: string;
  walletAddress: string;
}) {
  const { pagination, sorting } = useTableProps({
    pageSize: 15,
    initialSorting: '-datetime'
  });

  const [data, error] = useApi<PaginatedResponse<LiquidationBuyersData[]>>({
    url: `/markets/${marketAddress}/liquidations/collateral-buyers/${walletAddress}/`,
    queryParams: {
      page: pagination.currentPage,
      limit: pagination.pageSize,
      sort: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <TableSkeleton rows={10} />;
  }
  const columns: TableColumn<LiquidationBuyersData>[] = [
    {
      header: 'Collateral Amount',
      getCell: (row) => (
        <CurrencyValue
          value={row.collateral_amount}
          options={{
            currency: {
              name: row.underlying_symbol,
              address: row.underlying_address,
              network: network
            }
          }}
        />
      ),
      sortingField: 'collateral_amount'
    },
    {
      header: 'Base Amount',
      getCell: (row) => (
        <CurrencyValue
          value={row.base_amount}
          options={{
            currency: {
              name: row.market_underlying_symbol,
              address: row.market_underlying_address,
              network: network
            }
          }}
        />
      ),
      sortingField: 'base_amount',
      cellAlign: 'flex-end',
      headerAlign: 'flex-end'
    },
    {
      header: 'Time',
      getCell: (row) => (
        <RelativeDateTime
          value={row.datetime}
          formatDateTimeOptions={{ toRelativeUnit: 'days' }}
        />
      ),
      sortingField: 'datetime',
      cellAlign: 'flex-end',
      headerAlign: 'flex-end'
    }
  ];

  return (
    <CardTable<LiquidationBuyersData>
      title="Collateral Buys"
      rows={data['results']}
      columns={columns}
      getKey={(row) => row.wallet_address}
      sorting={sorting}
      pagination={{
        ...pagination,
        totalRecords: data.pagination.total
      }}
    />
  );
}
